import styles from './ProductSystemsCatalog.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React, { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { ProductSystemsCatalog as ProductSystemsCatalogType } from 'src/api/contentful/contentTypes.cloverdotcom';
import { Grid } from 'src/components/Grid/Grid';
import { GridContainer } from 'src/components/GridContainer/GridContainer';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { FlatEntry, flattenContentfulData } from 'src/services/cms/flattenContentful';
import { ProductSystemsCatalogCell } from './ProductSystemsCatalogCell';

interface ProductSystemsCatalogProps extends HTMLAttributes<HTMLElement> {
  entry?: FlatEntry<ProductSystemsCatalogType>;
}

const ProductSystemsCatalog: FC<ProductSystemsCatalogProps> = ({
  entry,
  className,
  style = {},
  ...props
}) => {
  const { t } = useTranslation();

  if (!entry) return null;
  const { backgroundColor, productSystemItems = [], title, titleColor } = entry;
  const TitleContainer = () => (
    <div className={styles.productSystemsCatalogGrid}>
      <GridContainer justifyContent="center">
        <Grid item xs={12} lg={8} xl={6} >
          <TextV2
            isMarkdown
            value={title}
            entry={{ ...entry, field: 'title' }}
            tagName="h2"
            variant="h2"
            className={styles.productSystemsCatalogTitle}
            style={{ color: titleColor }}
          />
        </Grid>
      </GridContainer>
    </div>
  );

  return (
    <section
      className={cx(styles.productSystemsCatalog, className)}
      style={{ backgroundColor: backgroundColor || style.backgroundColor }}
      {...props}
      role="main"
      aria-label={t('product-system-catalog.content')}
    >
      {title && <TitleContainer />}
      {productSystemItems.map(item => (
        <div key={item.id}>
          <ProductSystemsCatalogCell entry={item} />
        </div>
      ))}
    </section>
  );
};

ProductSystemsCatalog.displayName = 'ProductSystemsCatalog';

interface ProductSystemsCatalogWrapperProps extends HTMLAttributes<HTMLDivElement> {
  entry?: ReferencedEntry<ProductSystemsCatalogType>;
}

const ProductSystemsCatalogWrapper: FC<ProductSystemsCatalogWrapperProps> = ({ entry, ...props }) =>
  <ProductSystemsCatalog {...props} entry={flattenContentfulData(entry)} />;

  ProductSystemsCatalogWrapper.displayName = 'ProductSystemsCatalogWrapper';

export {
  ProductSystemsCatalog as _ProductSystemsCatalog,
  ProductSystemsCatalogWrapper as ProductSystemsCatalog,
};
